import { render, staticRenderFns } from "./SearchContacts.vue?vue&type=template&id=2c04ea02"
import script from "./SearchContacts.vue?vue&type=script&lang=ts"
export * from "./SearchContacts.vue?vue&type=script&lang=ts"
import style0 from "./SearchContacts.vue?vue&type=style&index=0&id=2c04ea02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports